module.exports = __webpack_public_path__ + "img/question.6dd93e77.svg";